import React, { useState } from 'react';
import { Header } from './components/Header';
import { ATLResonanceDashboard } from './components/ATLResonanceDashboard';
import { AnonymisedModal } from './components/AnonymisedModal';
export const App: React.FC = () => {
  const [timeRange, setTimeRange] = useState('30d');
  return <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-blue-50 font-sans" data-id="element-0">
      <AnonymisedModal data-id="element-1" />
      <Header timeRange={timeRange} setTimeRange={setTimeRange} data-id="element-2" />

      <main className="container mx-auto px-4 md:px-6 py-6 md:py-8" data-id="element-3">
        <ATLResonanceDashboard data-id="element-4" />
      </main>
    </div>;
};